import { useEffect, useRef } from 'react';
import $ from 'jquery';
import { HiOutlineAcademicCap } from 'react-icons/hi';
import { BsPeopleFill } from 'react-icons/bs';
import { FiCode, FiBriefcase } from 'react-icons/fi';

const timeline = [
  { year: '2026 – Now',  title: 'Web Dev Intern — Code212 UCA',           place: 'Bibliothèque Universitaire Cadi Ayyad',   Icon: FiBriefcase },
  { year: '2025 – 2026', title: '2nd year — Licence Sciences Informatiques', place: 'FSSM, Université Cadi Ayyad, Marrakech',  Icon: HiOutlineAcademicCap },
  { year: '2025 – 2026', title: 'Vice-President — Club Enactus FSSM',        place: 'Social entrepreneurship · competitions',  Icon: BsPeopleFill },
  { year: '2024 – 2025', title: '1st year MIP',                               place: 'FSSM, Université Cadi Ayyad, Marrakech', Icon: HiOutlineAcademicCap },
  { year: '2024',        title: 'HR Manager — Enactus & NOI FSSM',           place: 'Recruitment · onboarding · team mgmt',   Icon: BsPeopleFill },
  { year: '2022 – 2023', title: 'Baccalauréat Sciences Physiques',            place: 'Lycée Sidi Abderrahmane, Marrakech',     Icon: FiCode },
];

const aboutStats = [
  { target: 2, suffix: '+', label: 'Years Coding' },
  { target: 5, suffix: '+', label: 'Projects'     },
  { target: 3, suffix: '',  label: 'Languages'    },
];

export default function About() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      const $sec = $(entry.target);
      // Stagger timeline items
      $sec.find('.timeline-item').each((i, el) =>
        setTimeout(() => $(el).addClass('visible'), i * 120)
      );
      // Count-up stats
      $sec.find('.stat-number').each(function () {
        $(this).prop('counter', 0).animate({ counter: +$(this).data('target') }, {
          duration: 1400,
          step(now) { $(this).text(Math.ceil(now) + ($(this).data('suffix') || '')); },
        });
      });
      observer.disconnect();
    }, { threshold: 0.15 });

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className="about-section reveal">
      <h2 className="section-title">About <span>Me</span></h2>
      <div className="about-container">

        <div className="bio-card">
          <p>I'm a motivated <strong>2nd year CS student</strong> at FSSM, Université Cadi Ayyad,
          passionate about software development and data analysis.</p>
          <p>Beyond code I bring real leadership — currently <strong>Vice-President of Club
          Enactus FSSM</strong>, co-founder of <strong>"Fundithere"</strong>, and certified
          <strong> Ideation Trainer</strong> for Enactus Morocco's national network.</p>
          <p>I thrive in team environments and I'm always looking for the next challenge —
          hackathon, internship, or open-source project.</p>

          <div className="about-stats">
            {aboutStats.map((s, i) => (
              <div key={i} className="stat">
                <span className="stat-number" data-target={s.target} data-suffix={s.suffix}>0</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
          <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>

        <div className="timeline">
          {timeline.map((item, i) => (
            <div key={i} className="timeline-item">
              <div className="tl-icon"><item.Icon /></div>
              <div className="tl-body">
                <span className="tl-year">{item.year}</span>
                <h4 className="tl-title">{item.title}</h4>
                <p className="tl-place">{item.place}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
